import { ITableColumn } from '@components/common/UTable/UTable';

import { AutopsyActBrief } from '@/api/pathology/types';
import {
  ActStatusTag,
  ProcessingStageTag,
} from '@/pages/Pathology/components/common/ActTags';
import { formatDateTime } from '@/pages/Pathology/helpers';

export const columns: ITableColumn[] = [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: 'Дата вскрытия',
    dataIndex: 'performedAt',
    type: 'date',
    sorter: true,
  },
  {
    title: 'Инвентарный номер особи',
    dataIndex: 'individualInventoryNumber',
    sorter: true,
  },
  {
    title: 'Ветеринарный врач',
    dataIndex: 'veterinarianFullName',
    type: 'text',
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    sorter: true,
    render: (_value, record: AutopsyActBrief) => <ActStatusTag status={record.status} />,
  },
  {
    title: 'Обработка записи',
    dataIndex: 'processingStage',
    render: (_value, record: AutopsyActBrief) => (
      <ProcessingStageTag stage={record.processingStage} error={record.processingError} />
    ),
  },
  {
    title: 'Дата создания',
    dataIndex: 'createdAt',
    sorter: true,
    render: (value: string) => formatDateTime(value),
  },
];
